export const AutoSendStatus = {
  Stopped: 'stopped',
  Sending: 'sending',
} as const;
export type AutoSendStatus = (typeof AutoSendStatus)[keyof typeof AutoSendStatus];

export const EmergencyTimeStatus = {
  Unset: 'unset',
  Set: 'set',
} as const;
export type EmergencyTimeStatus = (typeof EmergencyTimeStatus)[keyof typeof EmergencyTimeStatus];

export const NotificationType = {
  StatusReport: 'statusReport',
  DispatchRequest: 'dispatchRequest',
  StandbyRelease: 'standbyRelease',
} as const;
export type NotificationType = (typeof NotificationType)[keyof typeof NotificationType];

export const SendMode = {
  Manual: 'manual',
  Auto: 'auto',
} as const;
export type SendMode = (typeof SendMode)[keyof typeof SendMode];

export const TransitionAction = {
  ManualOn: 'A',
  ManualOff: 'C',
  SetEmergencyTime: 'E',
  UnsetEmergencyTime: 'F',
  ResetEmergencyTime: 'G',
} as const;
export type TransitionAction = (typeof TransitionAction)[keyof typeof TransitionAction];

export type TemplateType = Extract<
  NotificationType,
  'dispatchRequest' | 'standbyRelease'
>;

export interface LiaisonState {
  /** 自動送信状態 */
  autoSendStatus: AutoSendStatus;
  /** 緊急放流予定時刻の設定状態 */
  emergencyTimeStatus: EmergencyTimeStatus;
  /** 送信継続起点時刻 (YYYYMMDDHHMM)。自動OFFの3hカウントの起点 */
  sendContinuationOriginTime: string | null;
  /** 送信停止時刻 (YYYYMMDDHHMM)。自動ON判定の起点 */
  sendStopTime: string | null;
  /** 緊急放流予定時刻 (YYYYMMDDHHMM)。人間が設定した予定時刻 */
  emergencyReleaseTime: string | null;
  /** 直近の自動送信実行時刻 (YYYYMMDDHHMM)。30分間隔判定に使用 */
  lastSentAt: string | null;
  /** レコード最終更新時刻 (ISO8601) */
  updatedAt: string | null;
}

export interface HistoryItem {
  /** 履歴レコードの一意ID */
  historyId: string;
  /** 実際に送信した時刻 (ISO8601) */
  sentAt: string;
  /** 通知種別 */
  type: NotificationType;
  /** 送信モード（手動/自動） */
  sendMode: SendMode;
  /** 送信した文面全文 */
  body: string;
}

export interface TemplateData {
  type: TemplateType;
  /** メールタイトル */
  subject: string;
  /** メール本文 */
  body: string;
  updatedAt: string | null;
}

export interface SendNotificationResponse {
  historyId: string;
  sentAt: string;
  newState: LiaisonState;
}

export interface PreviewResponse {
  body: string;
  hasEmergencyForecast: boolean;
  emergencyPredictionTime: string | null;
}

export interface LiaisonTarget {
  /** プロジェクトキー */
  projectKey: string;
  /** basinId */
  basinId: string;
  /** stationId */
  stationId: string;
  /** 表示名 */
  damName: string;
}
